import './email-verification.scss';
import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import { T } from 'shared/helper/translate';
import ResendVerificationEmail from './ResendVerificationEmail';
var HELP_CENTRE_URLS = {
  cn: 'https://customer-support.aje.com/portal/zh/kb/rubriq',
  default: 'https://customer-support.aje.com/portal/en/kb/rubriq'
};

/**
 * Shown once registration succeeds but the account still has to be verified.
 *
 * The account exists at this point - it just cannot be logged into until the
 * emailed link is followed, so there is deliberately no login attempt here.
 *
 * `alreadyPending` means this address had signed up before and never verified, so
 * what Megatron has just sent is a replacement link rather than a first one. Saying
 * so is what stops the second sign-up looking like it did nothing.
 */
var EmailVerificationPending = function EmailVerificationPending(_ref) {
  var _HELP_CENTRE_URLS$sit;
  var email = _ref.email,
    _ref$alreadyPending = _ref.alreadyPending,
    alreadyPending = _ref$alreadyPending === void 0 ? false : _ref$alreadyPending,
    onChangeEmail = _ref.onChangeEmail;
  var siteLanguage = useSelector(function (_ref2) {
    var application = _ref2.application;
    return application.siteLanguage;
  });
  var helpCentreUrl = (_HELP_CENTRE_URLS$sit = HELP_CENTRE_URLS[siteLanguage]) !== null && _HELP_CENTRE_URLS$sit !== void 0 ? _HELP_CENTRE_URLS$sit : HELP_CENTRE_URLS.default;
  return /*#__PURE__*/React.createElement("div", {
    className: "email-verification-pending"
  }, /*#__PURE__*/React.createElement(IdentifyPage, {
    title: "Verify your email address"
  }), /*#__PURE__*/React.createElement("div", {
    className: "verification-card mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "verification-icon mx-auto"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-regular fa-envelope"
  })), /*#__PURE__*/React.createElement("h1", {
    className: "verification-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.verify-your-email-address"
  })), /*#__PURE__*/React.createElement("p", {
    className: "verification-lead"
  }, alreadyPending ? /*#__PURE__*/React.createElement(T, {
    source: "rubriq.email-already-awaiting-verification"
  }) : /*#__PURE__*/React.createElement(T, {
    source: "rubriq.verification-email-sent-to"
  })), /*#__PURE__*/React.createElement("p", {
    className: "verification-email",
    "data-test": "email-verification-pending"
  }, email), /*#__PURE__*/React.createElement("div", {
    className: "verification-steps"
  }, /*#__PURE__*/React.createElement("p", {
    className: "steps-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.next-steps"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "rubriq.email-verification-next-steps"
  })), /*#__PURE__*/React.createElement(ResendVerificationEmail, {
    className: "resend-button",
    email: email,
    icon: "fa-light fa-arrows-rotate-reverse",
    label: "rubriq.resend-verification-email"
  }), onChangeEmail && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "change-email",
    onClick: onChangeEmail,
    "data-test": "change-email-address"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.change-email-address"
  })), /*#__PURE__*/React.createElement("hr", {
    className: "verification-divider"
  }), /*#__PURE__*/React.createElement("p", {
    className: "verification-help"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.verification-email-not-received"
  })), /*#__PURE__*/React.createElement("p", {
    className: "verification-help"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.need-help"
  }), ' ', /*#__PURE__*/React.createElement("a", {
    href: helpCentreUrl,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Contact support"
  })))), /*#__PURE__*/React.createElement("p", {
    className: "verification-footnote mx-auto"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.email-verification-footnote"
  })));
};
export default EmailVerificationPending;